// path: .../store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import friendSocketMiddleware from "./middleware/friendSocketMiddleware"; // Import here

const persistConfig = {
  key: "root",
  version: 1, // Increment this when you need to migrate/clear persisted state
  storage,
  // Suggest adding 'social' to blacklist so status is always fresh from DB/Socket
  blacklist: ["logout", "registration", "social"],
  // No longer clearing loggedUser on every load - it should persist across sessions
  // useAuthSync will validate and refresh user data as needed
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: false,
    }).concat(friendSocketMiddleware()); // Inject it here

    if (process.env.NODE_ENV !== "production") {
      const { logger } = require("redux-logger");
      return middleware.concat(logger);
    }

    return middleware;
  },
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
